export default {"src":"/_next/static/media/instagram.ac211dbd.svg","height":512,"width":512};